import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: Nullable<number>) => void;
	disabled: boolean;
}

const FranchiseFixedFeeAmountField: React.FC<IProps> = ({ onChange, disabled }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => (disabled ? [] : [{ required: true, message: t('enterFranchiseFixedFeeAmount') }]),
		[t, disabled],
	);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			onChange(value);
		},
		[onChange],
	);

	return (
		<FormInput
			testId="FranchiseFixedFeeAmountField"
			name="franchiseFixedFeeAmount"
			label="franchiseFixedFeeAmountLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={0}
			disabled={disabled}
		/>
	);
};

export default React.memo(FranchiseFixedFeeAmountField);
